module.exports = __webpack_public_path__ + "static/media/manual_white.e3735f88.svg";